<template>
    <div class="skillWrapper">
        <div class="skills"
             v-for="skill in skills"
             v-bind:key="skill.type">

            <h1>{{skill.type}}</h1>

            <div class="graph">
                <div class="item"
                     v-for="data in skill.data"
                     v-bind:key="data.name">
                    <div class="item-name" :style="{
                        fontSize: getSum(data)+'em'
                    }">{{data.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Timeline",
        props : {
            skills : Array
        },
        methods: {
            getSum:function(data){
                let sum = data.comfort.reduce(function(a, b){
                    return a + b;
                }, 0);

                let total = sum + data.personal;
                return total/13;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/scss/_variables.scss';
    @import '../assets/scss/_sectionWrappers.scss';

</style>
